import get from 'lodash/get';
import { call, put, race, take } from 'redux-saga/effects';
import { getInvalidOTPError } from 'helpers/otpErrors';
import App from 'modules/App';
import { verifyOtpSuccess, verifyOtpError } from 'modules/Account/actions';
import { VERIFY_OTP } from 'modules/Account/actionTypes';
import ApiService from './ApiService';
const API_ROOT = '/api/OtpSession';
function* sendOtp(signatureToken, otpRegion) {
    const requestUrl = `${API_ROOT}/Send`;
    return yield call(ApiService.crossRegionalRequest, otpRegion, requestUrl, {
        method: 'POST',
        headers: {
            'Signature-Token': signatureToken
        }
    });
}
function* getOtpStatus(otpSignatureToken, mfaRegion) {
    const requestUrl = `${API_ROOT}/Status`;
    return yield call(ApiService.crossRegionalRequest, mfaRegion, requestUrl, {
        headers: {
            'Signature-Token': otpSignatureToken
        }
    });
}
function* resendOtp(otpSignatureToken, otpRegion) {
    const requestUrl = `${API_ROOT}/Resend`;
    return yield call(ApiService.crossRegionalRequest, otpRegion, requestUrl, {
        method: 'POST',
        headers: {
            'Signature-Token': otpSignatureToken
        }
    });
}
function* verifyOtp(otp, otpSignatureToken, otpRegion, otpMethod) {
    const requestUrl = `${API_ROOT}/Verify`;
    try {
        const { signatureToken: verifiedOtpSignatureToken } = yield call(ApiService.crossRegionalRequest, otpRegion, requestUrl, {
            method: 'POST',
            headers: {
                'Signature-Token': otpSignatureToken
            },
            body: {
                otp
            }
        });
        return verifiedOtpSignatureToken;
    } catch (err) {
        const businessError = err.getBusinessError && err.getBusinessError();
        if (businessError && businessError.code === 'InvalidOTP') {
            const { failedAttempts, lockoutEnd } = businessError.params;
            const customErr = getInvalidOTPError(failedAttempts, otpMethod, lockoutEnd);
            yield call(App.dispatchError, customErr);
            throw customErr;
        }
        throw err;
    }
}
function* validateOtp(otpSignatureToken, otpRegion, otpMethod, cancelActionType) {
    let verifiedOtpSignatureToken = null;
    while(!verifiedOtpSignatureToken){
        const [enterOtpAction, cancelAction] = yield race([
            take(VERIFY_OTP),
            take(cancelActionType)
        ]);
        if (cancelAction) {
            return {
                signatureToken: otpSignatureToken,
                isCancelled: true
            };
        }
        const otp = get(enterOtpAction, 'payload.otp');
        try {
            verifiedOtpSignatureToken = yield call(verifyOtp, otp, otpSignatureToken, otpRegion, otpMethod);
        } catch (err) {
            const businessError = err.getBusinessError && err.getBusinessError();
            const failedAttempts = get(businessError, 'params.failedAttempts');
            const lockoutEnd = get(businessError, 'params.lockoutEnd');
            yield put(verifyOtpError(err, failedAttempts, lockoutEnd));
        }
    }
    yield put(verifyOtpSuccess());
    return {
        signatureToken: verifiedOtpSignatureToken,
        isCancelled: false
    };
}
export default {
    getOtpStatus,
    sendOtp,
    resendOtp,
    verifyOtp,
    validateOtp
};
